<template>
  <div>
    <div class="col-9 ms-auto me-5 px-3">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <div>
          <div class="body-title">Usuarios</div>
        </div>
        <div>
          <button
            id="modal-open"
            type="button"
            class="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#addUser"
            @click="focus()"
          >
            <i class="fa-solid fa-plus me-2" id="modal-open"></i>Agregar usuario
          </button>
        </div>
      </div>
      <!-- Add or Edit User -->
      <div
        class="modal fade"
        id="addUser"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <!-- Refactorizar -->
              <section v-if="user_id">
                <h5 class="modal-title fw-bold">Editar usuario</h5>
              </section>
              <section v-else>
                <h5 class="modal-title fw-bold">Agregar usuario</h5>
              </section>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <form @submit.prevent="user_id ? updateUser() : saveUser()" autocomplete="off">
                <div class="d-flex justify-content-between col-12 my-2">
                  <div class="col-5 form-group">
                    <label for="">Nombre:</label>
                    <input
                      id="name"
                      @keydown.enter="enterAsTab"
                      type="text"
                      name="name"
                      class="form-control"
                      v-model="user.name"
                      required
                    />
                  </div>
                  <div class="col-5 form-group">
                    <label for="">Rol:</label>
                    <select class="form-control" v-model="user.rol">
                      <option value="" disabled selected>Seleccionar rol</option>
                      <option v-for="(role, i) in allRoles" :key="i" :value="role">{{ role.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="d-flex justify-content-between col-12 my-2">
                  <div class="col-5 form-group">
                    <label for="">Email:</label>
                    <input type="email" class="form-control" v-model="user.email" required autocomplete="off" />
                  </div>
                  <div class="col-5 form-group">
                    <label for="">Contraseña:</label>
                    <input
                      type="password"
                      class="form-control"
                      v-model="user.password"
                      :disabled="user_id > 0"
                      required
                      autocomplete="off"
                    />
                  </div>
                </div>

                <div class="modal-footer">
                  <section v-if="user_id">
                    <button type="submit" class="btn btn-success" aria-label="Close">Editar usuario</button>
                  </section>
                  <section v-else>
                    <button type="submit" class="btn btn-success" aria-label="Close">Añadir usuario</button>
                  </section>
                  <button
                    id="modal-close"
                    type="button"
                    class="btn btn-danger"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="content-view">
        <paginate name="elements" :list="users" :per="15">
          <table class="table table-hover mt-3">
            <thead>
              <th>Id</th>
              <th>Nombre</th>
              <th>Email</th>
            </thead>

            <tbody class="position-relative">
              <!-- Refactorizar user_id y funcion de editar -->
              <tr
                v-for="(user, i) in paginated('elements')"
                :key="i"
                :id="`product-row-${i}`"
                @mouseenter="addOrRemoveDeleteOptClass($event)"
                @mouseleave="addOrRemoveDeleteOptClass($event)"
                @click="editUser(user), (user_id = user.id)"
              >
                <td>{{ user.id }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td class="deleteOpt text-danger" @click.stop="confirmDeleteUser(user.id)">
                  <i class="bi bi-trash-fill"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </paginate>

        <paginate-links
          for="elements"
          :limit="9"
          :hide-single-page="true"
          :show-step-links="true"
          :step-links="{
            next: '  ❯',
            prev: '❮  ',
          }"
        ></paginate-links>
      </div>
    </div>
  </div>
</template>

<script>
import VuePaginate from "vue-paginate";
import CurrencyInput from "../CurrencyInputComponent.vue";

export default {
  data() {
    return {
      user_id: 0,
      users: [],
      allRoles: [],
      rol: {
        name: "",
      },
      permissionsToAdd: [],
      permissionsToDelete: [],
      rolPermissions: [],
      models: [],

      product_id: 0,
      products: [],
      user: {
        name: "",
        rol: "",
        email: "",
        password: "",
      },
      productsToDelete: [],
      paginate: ["elements"],
    };
  },
  components: {
    VuePaginate,
    CurrencyInput,
  },
  methods: {
    getUsers() {
      axios.get("user/get-all-users").then((response) => {
        this.users = response.data.users;
      });
    },
    // Get all roles
    getRoles() {
      axios.get("/user/get-all-roles").then((response) => {
        this.allRoles = response.data.roles;
      });
    },
    // Create a new rol with their permission
    addRolAndPermissions() {
      axios
        .post("/permission", {
          name: this.rol.name,
          permissions: this.permissionsToAdd,
        })
        .then((response) => {
          if (response.data.success) {
            Swal.fire({
              icon: "success",
              text: response.data.success,
              timer: 2000,
            });
            this.getRoles();
          } else {
            Swal.fire({
              icon: "error",
              text: response.data.error,
              timer: 2000,
            });
          }
        });
    },
    editUser(user) {
      const { name, email, roles } = user;
      this.user = { name, email, rol: roles[0] };

      document.getElementById("modal-open").click();
    },

    // Clear all variables related to Create or Delete rol permissions
    /* Refactorizar */
    clearPermissions() {
      this.permissionsToDelete = [];
      this.permissionsToAdd = [];
      this.rol = {};
      this.indexAdd = -1; // Esta variable no deberia de ser global, deberia de existir solo en una funcion
      this.indexDelete = -1; // Esta variable no deberia de ser global, deberia de existir solo en una funcion
      this.rolPermissions = [];
      this.wantEdit = false;
      this.wantAdd = false;
    },
    // Confirm message before add or update any user
    confirmDeleteUser(id) {
      Swal.fire({
        title: `¿Deseas eliminar este usuario?`,
        showDenyButton: true,
        confirmButtonText: "Sí",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteUser(id);
        }
      });
    },
    // Delete user
    deleteUser(id) {
      axios.delete(`/user/${id}`).then((response) => {
        if (response.data.rolesError) {
          Swal.fire({
            icon: "error",
            title: "Existen usuarios utilizando este rol",
            text: response.data.rolesError,
          });
        } else {
          if (response.data.success) {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: response.data.success,
            });
            this.getUsers();
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: response.data.error,
            });
          }
        }
      });
    },
    /* Cambiar nombre por uno mas intuitivo */
    clearUser() {
      this.user_id = 0;
      this.user = {
        name      : "",
        rol       : "",
        email     : "",
        password  : "",
      };
    },
    focus() {
      setTimeout(() => {
        document.getElementById("name").focus();
      }, "500");
    },
    saveUser() {
      axios.post("user", this.user).then((response) => {
        if (response.data.success) {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: response.data.success,
          });
          this.getUsers();
          this.clearUser();
          document.getElementById("modal-close").click();
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: response.data.error,
          });
        }
      });
    },
    // Update the user
    updateUser() {
      axios.put(`/user/${this.user_id}`, this.user).then((response) => {
        if (response.data.success) {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: response.data.success,
          });
          this.getUsers();
          this.clearUser();
          document.getElementById("modal-close").click();
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: response.data.error,
          });
        }
      });
    },
  },
  computed: {},
  created() {
    this.getUsers();
    this.getRoles();
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  label {
    color: var(--first-color-dark);
  }
}

.invoice-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.body-title {
  font-weight: 900;
  font-size: var(--font-normal-title);
}

/* Table styles */
table {
  th {
    color: var(--first-color-dark);
  }

  td {
    padding: 0;
  }
  .selected {
    background: #c3c2c2;
  }

  .table-footer {
    border: white;
  }
}
.table-body {
  overflow: auto;
  height: 288px;
}
.modal-body {
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(57, 48, 48);
    border-radius: 10px;
  }
}

.paragraph {
  color: var(--first-color-dark);
}
.label-form {
  color: var(--first-color-dark);
}

div.swal2-actions {
  width: 50% !important;
  justify-content: space-around !important;
}

.form-check-input:checked {
  background-color: #198754;
  border-color: #198754;
}
.form-check-input {
  background-color: #dc3545;
  border-color: #dc3545;
  // background-image: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e);
}
</style>
